import { HubConnectionBuilder, HubConnectionState, LogLevel } from "@microsoft/signalr";
import type { HubConnection, IRetryPolicy, RetryContext } from "@microsoft/signalr";
import { useAuthStore } from "../../features/auth/stores/authStore";

// Retry forever: exponential backoff capped at 30s, with up to 1s of jitter so
// thousands of clients reconnecting after a server blip don't synchronize.
// The built-in fixed-array retry gives up after 4 attempts (~42s), which leaves
// long-lived tabs silently disconnected after any extended outage.
const infiniteRetryPolicy: IRetryPolicy = {
  nextRetryDelayInMilliseconds(retryContext: RetryContext): number {
    const base = Math.min(30_000, 1000 * 2 ** retryContext.previousRetryCount);
    const jitter = Math.random() * 1000;
    return base + jitter;
  },
};

export function createSignalRConnection(): HubConnection {
  return new HubConnectionBuilder()
    .withUrl("/hubs/entity-changes", {
      accessTokenFactory: () => useAuthStore.getState().token ?? "",
    })
    .withAutomaticReconnect(infiniteRetryPolicy)
    .configureLogging(LogLevel.Warning)
    .build();
}

export { HubConnectionState };
export type { HubConnection };
